<template>
    <div class="include-menu">
    <v-menu @input="handleMenuToggle" offset-y v-model="menuOpened" nudge-bottom="10" :content-class="'include-menu-container'" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <button
          :class="menuOpened ? 'include-menu-activator open' : 'include-menu-activator'"
          v-bind="attrs"
          v-on="on"
        >
          <template v-if="include=='any_of'">Include any of</template>
          <template v-if="include=='all_of'">Include all of</template>
          <!-- {{ include }} -->
          <template v-if="menuOpened"> <i class="ri-arrow-up-s-line"></i> </template>
          <template v-else><i class="ri-arrow-down-s-line"></i></template>
        </button>
      </template>
    <div class="include-menu-results-container">
        <div @click="handleSelect('any_of')" :class="include=='any_of' ? 'include-option selected' : 'include-option'">
            <template v-if="include=='any_of'">⎷</template>
            Include any of
        </div>
        <div @click="handleSelect('all_of')" :class="include=='all_of' ? 'include-option selected' : 'include-option'">
            <template v-if="include=='all_of'">⎷</template>
            Include all of
        </div>
    </div>
    </v-menu>
  </div>
</template>

<script>
export default {
    data(){
        return{
            include:"any_of",
            menuOpened: false,
        }
    },
    methods:{
        handleMenuToggle(val){
            console.log(val)
        },
        handleSelect(val){
            console.log(val)
            this.include = val
            setTimeout(()=>{ this.menuOpened=false },1000)
        }
    }

}
</script>

<style scoped>
.include-menu {
    margin-bottom: 16px;
}
.include-menu-activator {
    display: flex;
    padding: 8px 8px 8px 12px;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    border: 1px solid var(--neutrals-200, #EDEDED);
    background: var(--neutrals-white, #FFF);
    color: var(--neutrals-500, #666);
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 18px */
    letter-spacing: -0.12px;
    margin-left: 12px;
    cursor: pointer;
}

.include-menu-activator.open{
  border: 1px solid var(--primary-500, #5B7EDB);
  background: var(--primary-200, #F6F8FE);
  color: #5B7EDB;
  transition: all 0.1s;
}
.include-menu-container{
    display: inline-flex;
    padding: 10px 24px 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    border: 1px solid var(--neutrals-200, #EDEDED);
    background: var(--neutrals-white, #FFF);
    /* Shadow- L1 */
    box-shadow: 0px 0px 8px 0px rgba(102, 102, 102, 0.15);
}


.include-option{
    color: var(--neutrals-500, #666);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    height: 32px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.include-option.selected{
    color: var(--neutrals-600, #4C4C4C);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}


</style>